import { getRequest, postRequest, deleteRequest } from "./client";
import { TimeOffRequest, TimeOffRequestExtended, TimeOffRequestStatus } from "winslow-core";
import config from "environment";

const { baseApi } = config;

export async function apiGetTimeOffRequestsForWorkspace(workspaceId: string): Promise<TimeOffRequestExtended[] | null> {
  const fetchURL = `${baseApi}/time-off-requests/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetTimeOffRequestsForWorkspace");
}

export async function apiGetTimeOffRequest(id: string): Promise<TimeOffRequestExtended | null> {
  const fetchURL = `${baseApi}/time-off-requests/${id}`;
  return await getRequest(fetchURL, "API/apiGetTimeOffRequest");
}

export async function apiGetTimeOffRequestsForEmployeeRecord(id: string): Promise<TimeOffRequestExtended[] | null> {
  const fetchURL = `${baseApi}/time-off-requests/employee-record/${id}`;
  return await getRequest(fetchURL, "API/apiGetTimeOffRequestsForEmployeeRecord");
}

export async function apiCreateTimeOffRequest(data: Partial<TimeOffRequest>): Promise<TimeOffRequestExtended | null> {
  const fetchURL = `${baseApi}/time-off-requests/create`;
  return await postRequest(fetchURL, data, "API/apiCreateTimeOffRequest");
}

export async function apiUpdateTimeOffRequestStatus(id: string, status: TimeOffRequestStatus): Promise<TimeOffRequestExtended | null> {
  const fetchURL = `${baseApi}/time-off-requests/update-status`;
  return await postRequest(fetchURL, { id, status }, "API/apiUpdateTimeOffRequestStatus");
}

export async function apiDeleteTimeOffRequest(id: string): Promise<TimeOffRequestExtended | null> {
  const fetchURL = `${baseApi}/time-off-requests/${id}`;
  return await deleteRequest(fetchURL, "API/apiDeleteTimeOffRequest");
} 